import styled from '@emotion/styled'
import tw from 'twin.macro'

export const AllergensContainer = styled('p')`
  ${tw`text-sm leading-sm`}
  ${tw`mt-4 lg:mt-8 flex flex-col`}
  ${tw`sm:flex-row`}
  ${tw`p-2 border-0 border-l-2 border-grey-700 bg-grey-100`}
  padding-left: 0.625rem
`

export const NoticeContainer = styled.div`
  div {
    ${tw`mt-0 mb-0`}
  }
`
